import { Pipe, PipeTransform } from '@angular/core';
import { JobSummary } from '@jms/model';
import { DateTime } from 'luxon';

@Pipe({
  name: 'jobAge',
  standalone: true
})
export class JobAgePipe implements PipeTransform {

  transform(job: JobSummary): string {

    if (!job || !job.createdDate) return '';
    const createdDate = DateTime.fromISO(job.createdDate.toString());
    let diff = createdDate.diffNow('days').days;
    diff = Math.round(Math.abs(diff));

    if (diff === 0) return 'NEW';
    return diff + this.getDayLabel(diff);
  }

  private getDayLabel(dayCount: number) {
    dayCount = Math.round(dayCount);
    if (dayCount === 0) return '';
    return (dayCount === 1 || dayCount === -1) ? ' DAY' : ' DAYS';
  }

}
